import { notificationsVar } from './cache'
import { NOTIFICATION_TYPE } from 'components/Notifications/Notifications'

export const newNotification = (type, title, message) => {
    const notification = {
        type,
        message,
        title,
    }

    notificationsVar([...notificationsVar(), notification])
}

export const newSuccessNotification = (title, message) => {
    newNotification(NOTIFICATION_TYPE.SUCCESS, title, message)
}

export const clearNotifications = () => {
    notificationsVar([])
}
